import { ref, onBeforeMount } from 'vue';
import { MAINLAND_MERCHANT_RECOMMEND_POSID_LIST } from '@/config/module-config/mainland';
import { formatMultiContainerData } from '@/business';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { i18n } from '@/i18n';
import { useConfigStore } from '@/store';
import { MultiJumpContainerType } from '@/types/banner-layout';
import { ModuleName } from '@/types/module-type';

// 兜底图片
const defaultBanner = (isBig: boolean) => ({
  biTag: '',
  /** 调转链接h5 */
  jumpUrl: '',
  /** 跳转链接小程序 */
  appid: '',
  /** 跳转链接小程序用 */
  username: '',
  /** 图片详情 */
  imgUrl: isBig ? i18n('左侧大兜底图') : i18n('右侧小兜底图'),
  path: '',
});

/**
 * @description 获取热门优惠布局信息
 * @param  moduleName 通用模块名
 */
export function useMerchantLayoutInfo(moduleName: ModuleName) {
  const { getConfig } = useConfigStore();
  const bannerLayoutList = ref<MultiJumpContainerType[]>();

  const formateBannerLayoutList = (layoutList: DpItem[]) => {
    // 创建一个热门优惠推荐位布局列表的映射，以便快速查找
    const targetMap = new Map(layoutList.map(item => [item.dpPosition, item]));
    // 将布局列表按照 MAINLAND_MERCHANT_RECOMMEND_POSID_LIST 的顺序进行排列，如果某个布局元素不存在就为空
    const sortMerchantBannerLayoutList = MAINLAND_MERCHANT_RECOMMEND_POSID_LIST
      .map(ref => targetMap.get(ref) || null);
    // 格式化排序后的元素
    const formattedMerchantBannerLayoutList = sortMerchantBannerLayoutList.map((item, index) => {
      if (item) {
        return formatMultiContainerData(item);
      }
      if (index === 0) {
        return defaultBanner(true);
      }
      return defaultBanner(false);
    });
    return formattedMerchantBannerLayoutList;
  };

  onBeforeMount(async () => {
    const { filteredMerchantBannerLayoutList } = await getConfig(moduleName);
    bannerLayoutList.value = formateBannerLayoutList(filteredMerchantBannerLayoutList);
  });

  return {
    /** 热门优惠布局列表 */
    bannerLayoutList,
  };
}
